module.exports = __webpack_public_path__ + "img/level_one_hover.ce69efd4.png";